import { Injectable, Injector } from "@angular/core";
import { Department } from "@enums/department.enum";
import { MachineRequestType } from "@enums/machineRequestType.enum";
import { environment } from "@environments/environment";
import { CloseSupervisorRequest } from "@interfaces/closeSupervisorRequest.interface";
import { DownloadWorkforceReport } from "@interfaces/downloadWorkforceReport.interface";
import { Service } from "@services/service";

@Injectable()
export class MachineService extends Service {
	constructor(injector: Injector) {
		super("Machine", injector);
	}

	// API
	app_CloseSupervisorRequest(data: CloseSupervisorRequest) {
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/App_CloseSupervisorRequest`, data);
	}

	app_OpenMachineRequestForStage(stageId: number, requestType: MachineRequestType){
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/App_OpenMachineRequestForStage/${stageId}/${requestType}`, {} );
	}

	app_OpsPlannerFirewallOrders() {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/App_OpsPlannerFirewallOrders` );
	}

	app_OpsPlannerForDepartment(department: Department) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/App_OpsPlannerForDepartment/${department}` );
	}

	app_OpsPlannerForDepartmentAndDate(department: Department, date: Date) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/App_OpsPlannerForDepartmentAndDate/${department}/${date.toDateString()}` );
	}
	
	app_OpsPlannerForMachine(machineId: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/App_OpsPlannerForMachine/${machineId}` );
	}	

	app_OpsPlannerForMachineAndDate(machineId: number, date: Date) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/App_OpsPlannerForMachineAndDate/${machineId}/${date.toDateString()}` );
	}	

	app_OpsPlannerForSite(siteId: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/App_OpsPlannerForSite/${siteId}` );
	}

	app_OpsPlannerForSiteAndDate(siteId: number, date: Date) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/App_OpsPlannerForSiteAndDate/${siteId}/${date.toDateString()}` );
	}

	app_OpsPlannerUnestimatedForDepartment(department: Department) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/App_OpsPlannerUnestimatedForDepartment/${department}` );
	}
	
	app_ToolroomOverview(siteId: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/App_ToolroomOverview/${siteId}`);
	}

	app_opsPlannerUnestimatedForSite(siteId: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/App_OpsPlannerUnestimatedForSite/${siteId}` );
	}

	app_requestSupervisor(machineId: number, reasonId: number){
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/App_RequestSupervisor/${machineId}/${reasonId}`, {} );
	}

	app_requestSupervisorForStage(stageId: number, reasonId: number){
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/App_RequestSupervisorForStage/${stageId}/${reasonId}`, {} );
	}

	app_updateProductionStatus(id: number, status: number) {
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/App_UpdateProductionStatus/${id}/${status}`, {} );
	}

	downloadWorkforceReport(data: DownloadWorkforceReport) {
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/WorkforceReport`, data, { responseType: "blob" as "json"} );
	}

	floorPlanMachineSummary(id: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/FloorPlanMachineSummary/${id}` );
	}

	getByDepartment(department: Department) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/GetByDepartment/${department}` );
	}

	getBySite(siteId: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/GetBySite/${siteId}` );
	}

	getCalendarPdf() {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/GetCalendarPdf`, { responseType: "blob" as "json"} );
	}

	openMachineRequestSupervisor(stageId: number, requestType: MachineRequestType){
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/OpenMachineRequestSupervisor/${stageId}/${requestType}`, {} );
	}
	
	opsPlannerFirewallOrders() {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/OpsPlannerFirewallOrders` );
	}
	
	opsPlannerForDepartment(department: Department) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/OpsPlannerForDepartment/${department}` );
	}
	
	opsPlannerForDepartmentAndDate(department: Department, date: Date) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/OpsPlannerForDepartmentAndDate/${department}/${date.toDateString()}` );
	}
	
	opsPlannerForSite(siteId: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/OpsPlannerForSite/${siteId}` );
	}
	
	opsPlannerForSiteAndDate(siteId: number, date: Date) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/OpsPlannerForSiteAndDate/${siteId}/${date.toDateString()}` );
	}

	opsPlannerUnestimatedForDepartment(department: Department) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/OpsPlannerUnestimatedForDepartment/${department}` );
	}
	
	opsPlannerUnestimatedForSite(siteId: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/OpsPlannerUnestimatedForSite/${siteId}` );
	}

	toolroomOverview(siteId: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/ToolroomOverview/${siteId}`);
	}

	updateProductionStatusSupervisor(id: number, status: number) {
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/UpdateProductionStatusSupervisor/${id}/${status}`, {} );
	}
}